import { createReducer } from "sc/helpers/reducer";
import {
  SHIFTS_DEFINITIONS_LOADED,
  SHIFT_DEFINITION_CREATED,
  SHIFT_DEFINITION_DELETED,
  SHIFT_DEFINITION_UPDATED,
  SHIFT_DEFINITION_MOVED,
  SHIFT_DEFINITION_ERROR,
  REQUEST_CREATE_SHIFT_DEFINITION,
  REQUEST_UPDATE_SHIFT_DEFINITION,
  REQUEST_MOVE_SHIFT_DEFINITION,
  REQUEST_DELETE_SHIFT_DEFINITION,
  SHIFT_DEFINITION_CLICKED,
} from "../actions/shifts-definitions";
import { LOCATION_CHANGE } from "react-router-redux/reducer";
import moment from "moment";

export default createReducer(
  { list: null, selected: null, error: "" },
  {
    [LOCATION_CHANGE]: (state, action) => ({ list: null, error: "" }),
    [SHIFTS_DEFINITIONS_LOADED]: (state, action) => ({
      list: action.payload.shiftsDefinitions,
      error: "",
      selected: null,
    }),
    [SHIFT_DEFINITION_CLICKED]: (state, action) =>
      Object.assign({}, state, {
        selected: computeSelectedShiftDefinition(
          state.list,
          state.selected,
          action.payload.shiftDefinition,
        ),
      }),
    [REQUEST_CREATE_SHIFT_DEFINITION]: (state, action) =>
      Object.assign({}, state, { error: "" }),
    [REQUEST_UPDATE_SHIFT_DEFINITION]: (state, action) =>
      Object.assign({}, state, { error: "" }),
    [REQUEST_MOVE_SHIFT_DEFINITION]: (state, action) =>
      Object.assign({}, state, { error: "" }),
    [REQUEST_DELETE_SHIFT_DEFINITION]: (state, action) =>
      Object.assign({}, state, { error: "" }),
    [SHIFT_DEFINITION_CREATED]: (state, action) =>
      Object.assign({}, state, {
        list: addShiftDefinition(state.list, action.payload.shiftDefinition),
        error: "",
        selected: action.payload.shiftDefinition,
      }),
    [SHIFT_DEFINITION_DELETED]: (state, action) =>
      Object.assign({}, state, {
        ...deleteShiftDefinition(state.list, action),
        error: "",
        selected: null,
      }),
    [SHIFT_DEFINITION_UPDATED]: (state, action) =>
      Object.assign({}, state, {
        ...updateShiftDefinition(state.list, action),
        error: "",
      }),
    [SHIFT_DEFINITION_MOVED]: (state, action) =>
      Object.assign({}, state, {
        ...moveShiftDefinition(state.list, action),
        error: "",
      }),
    [SHIFT_DEFINITION_ERROR]: (state, action) =>
      Object.assign({}, state, { error: action.payload.message }),
  },
);

const computeSelectedShiftDefinition = (
  shiftDefinitions,
  selected,
  clicked,
) => {
  if (clicked.id === undefined) {
    // That's a placeholder
    return null;
  }
  if (selected !== null && selected.id === clicked.id) {
    // That's a second click on the selected shift definition
    return null;
  }
  return clicked;
};

const addShiftDefinition = (list, shiftDefinition) => {
  const newList = [...list, shiftDefinition];
  newList.sort((shiftDefinition, otherShiftDefinition) =>
    moment(startDate(shiftDefinition)).diff(startDate(otherShiftDefinition)),
  );
  return newList;
};

const deleteShiftDefinition = (list, action) => {
  const newList = list.filter(
    shiftDefinition => shiftDefinition.id !== action.payload.id,
  );
  return {
    list: newList,
    selected: null,
  };
};

const updateShiftDefinition = (list, action) => {
  const oldShiftDefinition = list.find(
    shiftDefinition => shiftDefinition.id === action.payload.oldId,
  );
  const newShiftDefinition = {
    ...oldShiftDefinition,
    id: action.payload.newId,
    startDate: action.payload.startDate,
    startTime: action.payload.startTime,
    days: action.payload.days,
    endTime: action.payload.endTime,
    priority: action.payload.priority,
  };
  const newList = list.filter(
    shiftDefinition => shiftDefinition.id !== action.payload.oldId,
  );
  newList.push(newShiftDefinition);
  newList.sort((shiftDefinition, otherShiftDefinition) => {
    if (
      moment(startDate(shiftDefinition)).diff(
        startDate(otherShiftDefinition),
      ) === 0
    ) {
      return (
        parseInt(shiftDefinition.priority, 10) -
        parseInt(otherShiftDefinition.priority, 10)
      );
    } else {
      return moment(startDate(shiftDefinition)).diff(
        startDate(otherShiftDefinition),
      );
    }
  });
  return {
    list: newList,
    selected: newShiftDefinition,
  };
};

const moveShiftDefinition = (list, action) => {
  const oldShiftDefinition = list.find(
    shiftDefinition => shiftDefinition.id === action.payload.oldId,
  );
  const newShiftDefinition = {
    ...oldShiftDefinition,
    startDate: action.payload.startDate,
    id: action.payload.newId,
  };
  const newList = list.filter(
    shiftDefinition => shiftDefinition.id !== action.payload.oldId,
  );
  newList.push(newShiftDefinition);
  newList.sort((shiftDefinition, otherShiftDefinition) => {
    if (
      moment(startDate(shiftDefinition)).diff(
        startDate(otherShiftDefinition),
      ) === 0
    ) {
      return (
        parseInt(shiftDefinition.priority, 10) -
        parseInt(otherShiftDefinition.priority, 10)
      );
    } else {
      return moment(startDate(shiftDefinition)).diff(
        startDate(otherShiftDefinition),
      );
    }
  });
  return {
    list: newList,
    selected: newShiftDefinition,
  };
};

export const startDate = function(shiftDefinition) {
  const startTimeComponents = shiftDefinition.startTime.split(":");
  const startComponents = shiftDefinition.startDate.split("-");
  return new Date(
    startComponents[0],
    startComponents[1] - 1,
    startComponents[2],
    startTimeComponents[0],
    startTimeComponents[1],
  );
};

export const endDate = function(shiftDefinition) {
  const start = startDate(shiftDefinition);
  const endTimeComponents = shiftDefinition.endTime.split(":");
  const end = new Date(start.valueOf());
  end.setDate(end.getDate() + shiftDefinition.days);
  end.setHours(endTimeComponents[0]);
  end.setMinutes(endTimeComponents[1]);
  return end;
};



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/shifts-definitions-reducer.js